/* eslint-disable no-console */
var DEV = process.env.NODE_ENV !== 'production';
var identity = function identity(x) {
  return x;
};
var is = function is(n) {
  return n !== undefined && n !== null;
};
var num = function num(n) {
  return typeof n === 'number' && !Number.isNaN(n);
};
var string = function string(n) {
  return typeof n === 'string' && n !== '';
};
var obj = function obj(n) {
  return typeof n === 'object' && n !== null;
};
var negative = function negative(n) {
  return num(n) && n < 0;
};
var get = function get(from, path) {
  var paths = String(path).split('.');
  var pathsLength = paths.length;
  var result = from;

  for (var i = 0; i < pathsLength; i += 1) {
    if (result === undefined) return result;
    var _path = paths[i];
    result = is(result[_path]) ? result[_path] : undefined;
  }

  return result;
};
var assign = function assign(a, b) {
  if (!is(b)) return a; // eslint-disable-next-line no-restricted-syntax, guard-for-in

  for (var key in b) {
    a[key] = b[key];
  }

  return a;
};
var merge = function merge(a, b) {
  if (!is(b)) return a; // eslint-disable-next-line no-restricted-syntax

  for (var key in b) {
    // eslint-disable-next-line no-continue
    if (obj(a[key])) {
      a[key] = merge(assign({}, a[key]), b[key]);
    } else {
      a[key] = b[key];
    }
  }

  return a;
};
var warn = function warn(condition, message) {
  if (DEV) {
    if (!condition && console.error) {
      console.error(message);
    }
  }
};
function cascade(value, arg) {
  if (typeof value === 'function') {
    return cascade(value(arg), arg);
  }

  return value;
}
var getThemeValue = function getThemeValue(props, path, initial) {
  if (initial === void 0) {
    initial = props.theme;
  }

  return cascade(get(initial, path), props);
};

export { assign, cascade, get, getThemeValue, identity, is, merge, negative, num, obj, string, warn };
//# sourceMappingURL=xstyled-util.es.js.map
